import * as api from '@userManager/api';
import * as MutationTypes from '../mutationTypes';
import { UserRole } from '../models';

export const userRoleListRequest = async ({ commit }) => {
  const response = await api.userRoleListRequest();
  const userRoleList = UserRole.toInstanceList(response.data);
  commit(MutationTypes.USER_ROLE_LIST_SUCCESS, userRoleList);
};

export const createUserRoleRequest = async ({ commit }, userRole) => {
  const serializedUserRole = userRole.serialize();
  const response = await api.createUserRoleRequest(serializedUserRole);
  const newUserRole = UserRole.toInstance(response.data);
  commit(MutationTypes.CREATE_USER_ROLE_SUCCESS_SUCCESS, newUserRole);
};

export const updateUserRoleRequest = async ({ commit }, userRole) => {
  const serializedUserRole = userRole.serialize();
  const { username } = serializedUserRole.user;
  delete serializedUserRole.user.username;
  const response = await api.updateUserRoleRequest(username, serializedUserRole);
  const newUserRole = UserRole.toInstance(response.data);
  commit(MutationTypes.UPDATE_USER_ROLE_SUCCESS, newUserRole);
};

export const deleteUserRoleRequest = async ({ commit }, userRole) => {
  await api.deleteUserRoleRequest(userRole.user.username);
  commit(MutationTypes.DELETE_USER_ROLE_SUCCESS, userRole);
};

export const regeneratePasswordUserRoleRequest = async ({ commit }, userRole) => {
  await api.regeneratePasswordUserRoleRequest(userRole.user.username);
  commit(MutationTypes.REGENERATE_PASSWORD_USER_ROLE_SUCCESS, userRole);
};
